export class ChannelTargetData {
  constructor(
    public name: string,
    public status: string,
    public target: string,
    public channelName: string,
    public platformId: number,
    public availabilityZoneId: number,
    public availabilityZoneName: string,
    public type: string,
    public bitrate: number,
    public uptime: string,
  ) {}
}
